import axios from '_u/axios'

// 资讯列表
export const informationList = (body) => {
    return axios.post('api/notify/info/list', body)
}

// 查询资讯详情
export const informationView = (id) => {
    return axios.post('api/notify/info/view', { id })
}

// 新增资讯
export const informationAdd = (body) => {
    return axios.post('api/notify/info/add', body)
}

// 修改资讯
export const informationUpdate = (body) => {
    return axios.post('api/notify/info/update', body)
}

// 删除
export const informationDelete = (id) => {
    return axios.post('api/notify/info/delete', { id })
}

// 查询公司详情
export const corpView = () => {
    return axios.post('api/corp/info/view')
}

// 修改公司
export const corpUpdate = (body) => {
    return axios.post('api/corp/info/update', body)
}

export const addOrUpdate = (body) => {
    return axios.post('api/corp/info/save', body)
}